import {PortalConfiguration} from "./PortalConfiguration.js";

/**
 * This is to be copied from the etc/config.js in the production environment
 */

export const PortalConfig:PortalConfiguration = {
	APIUrl: "/api.php/",
	language: "en",
	frontendUrl: "/",
	title: 'Poortinstructie',
	participant: {
		requireEmail: true,
		requireCompany: false,
		skipEmailForSection: true
	},
	logClientErrors: false
} as const;